<template>
  <div
    v-if="text"
    class="bg-[#fffaf6] box-border flex flex-col gap-[10px] items-start overflow-clip pl-[22px] pr-[16px] py-[16px] relative rounded-[4px] my-6"
    :data-blok-c="dataBlokC"
    :data-blok-uid="dataBlokUid"
  >
    <div class="flex flex-col gap-[10px] items-start relative shrink-0 w-full">
      <div class="h-[16px] relative shrink-0 w-[20px]">
        <img src="/assets/icons/updates/quote.svg" alt="" class="block max-w-none size-full" />
      </div>
    </div>
    <p
      class="font-normal italic leading-[1.5rem] min-w-full relative shrink-0 text-[1rem] text-[#6b5744] w-[min-content]"
      v-html="formattedText"
    ></p>
    <p
      v-if="author"
      class="font-normal leading-[1.25rem] min-w-full not-italic relative shrink-0 text-[0.875rem] text-[#353535] tracking-[-0.14px] w-[min-content]"
    >
      — {{ author }}
    </p>
    <div class="absolute bg-[#b59374] h-full left-0 top-0 w-[6px] rounded-l-[4px]"></div>
  </div>
</template>

<script>
export default {
  name: 'ContentQuote',
  props: {
    text: {
      type: String,
      default: '',
    },
    isHtml: {
      type: Boolean,
      default: false,
    },
    author: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'medium',
      validator: value => ['small', 'medium', 'large'].includes(value),
    },
    dataBlokC: {
      type: String,
      default: '',
    },
    dataBlokUid: {
      type: String,
      default: '',
    },
  },
  computed: {
    formattedText() {
      if (!this.text) return '';
      return this.isHtml ? this.text : this.escapeHtml(this.text);
    },
  },
  methods: {
    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    },
  },
};
</script>

<style scoped>
* {
  font-family: 'Inter', 'aktiv-grotesk', sans-serif;
}

:deep(b),
:deep(strong) {
  font-weight: 600;
}

:deep(i),
:deep(em) {
  font-style: italic;
}

:deep(u) {
  text-decoration: underline;
}
</style>
